<template>

  <svg
    t="1640066217655"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3996"
    width="64"
    height="64"
  ><path d="M510.95 182c167.76 0 312.6 95.46 434.46 286.35l7.59 12.06c12 19.35 12 43.86 0 63.24C829.52 742.55 682.16 842 510.92 842c-167.94 0-312.18-95.61-432.75-286.8l-7.35-11.85a59.97 59.97 0 0 1 0-62.7C192.89 281.6 339.59 182 510.95 182z m0 60C362.72 242 234.02 329.33 122 512l6.96 11.19C239.39 698.27 365.72 782 510.95 782c148.26 0 277.68-87.36 391.02-270l-7.2-11.4C783.17 325.7 656.15 242 510.98 242z m0.06 90a180.06 180.06 0 0 1 180.09 180c0 99.42-80.61 180-180.09 180a180.06 180.06 0 0 1-180.12-180c0-99.42 80.64-180 180.12-180z m0 60a120.03 120.03 0 1 0 0 240 120.03 120.03 0 1 0 0-240z" p-id="3997" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShow',
} as DefineComponent
</script>